export default __webpack_public_path__ + "static/BarryMcCahill-ae79d2c114e009afdc035d151f15f9fc.jpg";